/**
 * @Author: 陈瑞鹏
 * @Date:   2022-09-07 13:52:43
 * @Last Modified by:   陈瑞鹏
 * @Last Modified time: 2022-09-09 12:55:55
 */
import axios from 'axios'
import Qs from 'qs'
import store from 'STORE/index'

import {
    getAccessToken,
    removeAccessToken,
    cachedAdminInfo
} from 'API/cacheService'

import {
    IS_LOGIN,
    SHOW_TOKEN_ERROR
} from 'STORE/mutation-types'

/* eslint-disable */
const API_ROOT = 'https://api.ah-tianrui.com/index.php'
const API_ROOT_DEV = 'https://api.ah-tianrui.com/index.php'

/* eslint-enable */
axios.defaults.baseURL = (process.env.NODE_ENV === 'production' ? API_ROOT : API_ROOT_DEV)

axios.defaults.headers.Accept = 'application/json'

// Add a request interceptor
axios.interceptors.request.use(function(config) {
    if (config.url.indexOf('a/') === 0) {
        if (getAccessToken()) {
            config.headers['accessToken'] = getAccessToken()
        }
    }
    return config
}, function(error) {
    return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function(response) {
    if (response.data.code < 0) {
        if (response.data.code === -4001) {
            // 清空登录信息
            removeAccessToken()
            cachedAdminInfo.delete()
                //  弹出提示信息
            store.commit(SHOW_TOKEN_ERROR, true)
                //  弹出登录窗口
            store.commit(IS_LOGIN, false)
        }
        let error = {
            msg: response.data.msg
        }
        return Promise.reject(error)
    }
    return response.data
}, function(error) {
    error = {
        msg: '请求出错'
    }
    return Promise.reject(error)
})

export default {
    /**
     * 管理员登录
     */
    adminLogin(params) {
        return axios.post('a/login', Qs.stringify(params))
    },
    /**
     * 获取七牛token
     */
    getQiniuToken(withWater) {
        return axios.get('a/qiniu/token', {
            params: {
                bucket: 'qiniu-crpstc',
                withWater: withWater
            }
        })
    },
    /**
     * 上传图片到七牛
     */
    uploadToQiniu(params) {
        return axios.post('http://up-z0.qiniu.com', params, {
            headers: {
                'content-type': 'multipart/form-data'
            },
            withCredentials: false
        })
    },

    /**
     * 获取用户列表
     */
    getUserList(params) {
        return axios.post('w/ble/getUserList', Qs.stringify(params))
    },

    /**
     * 获取用户列表
     */
    getSbList(params) {
        return axios.post('w/ble/getSbList', Qs.stringify(params))
    },


    /**
     * 修改音乐配置
     */
    updateMusic(params) {
        return axios.post('w/music/updateMusic', Qs.stringify(params))
    },

    getVersion(params) {
        return axios.post('w/ble/getVersion', Qs.stringify(params));
    },

    getInfoList2(params) {
        return axios.post('w/ble/getInfoList2', Qs.stringify(params));
    },
    updateVersion(params) {
        return axios.post('w/ble/updateVersion', Qs.stringify(params))
    },
    addVersion(params) {
        return axios.post('w/ble/addVersion', Qs.stringify(params))
    },
}


// WEBPACK FOOTER //
// ./src/api/index.js